import { useSelector } from "react-redux";

import { DataTable } from "../../../components/DataTable";
import { setBillingLocationsPagination, setBillingLocationsScrollTop } from "../../../reducers/billingLocationsReducer";
import {
  getBillingLocations,
  getBillingLocationsList,
  getBillingLocationsScrollTop,
  getIsBillingLocationsStatusLoading,
} from "../../../selectors/billingLocations";
import { BillingLocationsTableType } from "../../../types/billingLocations";
import { useGetBillingLocationsTableColumns } from "./useGetBillingLocationsTableColumns";
import { useGetBillingLocationsTableHandlers } from "./useGetBillingLocationsTableHandlers";

import styles from "./BillingLocationsTable.module.scss";

type BillingLocationsTableProps = {
  tableType: BillingLocationsTableType;
};

export const BillingLocationsTable: React.FC<BillingLocationsTableProps> = ({ tableType }) => {
  const data = useSelector(getBillingLocationsList);
  const columns = useGetBillingLocationsTableColumns(tableType);
  const isLoading = useSelector(getIsBillingLocationsStatusLoading);
  const scrollTop = useSelector(getBillingLocationsScrollTop);
  const billingLocationsState = useSelector(getBillingLocations);
  const { handleAdditionalRowClick } = useGetBillingLocationsTableHandlers();

  return (
    <DataTable
      className={styles.container}
      dataRows={data}
      columns={columns}
      scrollTop={scrollTop}
      setScrollTop={setBillingLocationsScrollTop}
      setPagination={setBillingLocationsPagination}
      isLoading={isLoading}
      sliceState={billingLocationsState}
      handleAdditionalRowClick={handleAdditionalRowClick}
    />
  );
};
